// extracted by mini-css-extract-plugin
module.exports = {"tag":"MakeModelYearTag-module__tag"};